// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3AZCf","signatureButtonsRight":"ModalSign_signatureButtonsRight__2FOHB"};